<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="Heading-1" id="_idParaDest-5"><a id="_idTextAnchor005"></a>Epigraph</h1>
<p class="Epigraph-La">… foliis tantum ne carmina manda,</p>
<p class="Epigraph-La">ne turbata volent rapidis ludibria ventis;</p>
<p class="Epigraph-La">ipsa canas oro.</p>
<p class="Epigraph-space">‘… do not set your songs down on the leaves,</p>
<p class="Epigraph-En">For they will fly away on the rushing winds,</p>
<p class="Epigraph-En">Which will scatter them like toys abandoned;</p>
<p class="Epigraph-En">Sing yourself, I pray.’</p>
<p class="Epigraph-source"><em class="italic">Aeneid</em> 6.74–6</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-5.vue?6f70d6e0